import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { ResetPasswordService } from '../../services/resetPassword.service';
import { constants } from '../../shared/constants';
import { AppState } from 'src/app/app.state';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})

export class EmailComponent implements OnInit {
  isSubmitted: boolean = false;
  Emailform: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+[.]+[a-z]{2,4}$")])
  });
  emailAddress: any;
  isLoader: boolean = false;
  userName: string = null;
  userId: string = null;
  resetCode: String = null;
  errorEmail: boolean = null;
  toName: String = null;
  displayFlag: boolean = false;
  hideFields: boolean = true;

  constructor(
    private userService: UserService,
    private resetPasswordService: ResetPasswordService,
    private appState: AppState) { }

  ngOnInit() {}

  validateEmail() {
    this.isSubmitted = true;
    this.emailAddress = this.Emailform.value.email;
    if (this.Emailform.status == 'VALID') {
      this.isLoader = true;
      let input = {
        "where": {
          "email": this.emailAddress
        }
      }
      this.userService.GetUsers(input).subscribe(
        {
          next: (res) => {

            if (res && res.length > 0) {
              this.errorEmail = false;
              this.userName = res[0].companyId + "+" + res[0].email;
              this.toName = res[0].firstName + " " + res[0].lastName;

              this.resetLink(this.userName);
            } else {
              this.isLoader = false;
              this.errorEmail = true;
            }

          },
          error: (err) => {
            console.log('getUser data endpoint error!!', err);
          }
        }
      );

    }

  }
  resetLink(username) {
    let resetLinkInput = {
      "userName": username
    }
    this.resetPasswordService.getResetLink(resetLinkInput).subscribe({
      next: (res) => {
        if (res && res.StatusCode == 200 && res.Message == "Reset password mail has been send to registered mail") {
          this.userId = res.userId;
          this.resetCode = res.resetCode;
          if (this.userId && this.userId != null) {
            let url = "https://" + this.appState.companyInfoValue?.sellBaseUrl + "/reset-password" + "?userId=" + this.userId + "&resetCode=" + this.resetCode;
            let sendMsgInput = {
              "to": this.emailAddress,
              "toName": this.toName,
              "url": url,
              "messageId": constants.reset_password_messageId,
              "subject": constants.reset_password_subject,
              "from": constants.reset_password_from,
              "fromName": constants.reset_password_fromName
            }
            //call email endpoint 
            this.resetPasswordService.sentMessage(sendMsgInput).subscribe({
              next: (res) => {
                if (res && res.status.code == 200 && res.status.message == 'Success') {
                  this.hideFields = false;
                } else {
                  console.log('email sending failed');
                  this.hideFields = true;
                }

              }
            });

          } else {
            console.log('failed to get username from getUserData api');
          }
        }

      }, error: (err) => {

        console.log('getUser data endpoint error!!', err);
      }
    });

  }

}